/**
 * Per-browser record of which applications the user opens in the Run view —
 * feeds the app picker's "Recently used" / "Frequently used" sorts. Kept in
 * localStorage (the platform has no per-user app-usage store); a blocked or
 * full storage just means those two sorts fall back to the name order.
 */
const KEY = 'twasta.run.appUsage.v1'

export interface AppUsage { opens: number; last: number }
export type UsageMap = Record<string, AppUsage>

export function loadUsage(): UsageMap {
  try {
    const raw = window.localStorage.getItem(KEY)
    const parsed = raw ? JSON.parse(raw) : {}
    return parsed && typeof parsed === 'object' ? parsed as UsageMap : {}
  } catch {
    return {}
  }
}

export function recordRun(project: string): void {
  if (!project) return
  try {
    const all = loadUsage()
    const cur = all[project]
    all[project] = { opens: (cur?.opens || 0) + 1, last: Date.now() }
    window.localStorage.setItem(KEY, JSON.stringify(all))
  } catch {
    // Usage ranking is a convenience; never block running the app on it.
  }
}
